import { deleteRequest, get, post } from './_defaults/fetch.js';

export const getModels = (params, config) => get('/models', { params, ...config });
export const getModel = ({ id, params, config }) => get(`/models/${id}`, { params, ...config });
export const createModel = (body, config) => post('/models', body, config);
export const updateModel = ({ id, data, config }) => post(`/models/${id}`, data, config);
export const deleteModel = (id, config) => deleteRequest(`/models/${id}`, null, config);
